export default __webpack_public_path__ + "static/media/mic.b3d782de.png";